import axios from "axios";
import { API_URLS } from "../../../../core/data/redux/apis/urls";
import { tokenService } from "../../../../core/utils/tokenService";

export interface AllotmentLetterTemplate {
  templateType: string;
  signatoryName?: string;
  signatoryDesignation?: string;
  terms?: string[];
  copyToList?: string[];
  ccTo?: string;
  fileNumberPrefix?: string;
  rulesReferenceDate?: string;
  possessionDeadlineDays?: number;
}

export interface AllotmentLetterFormValues {
  allotmentId?: string | number;
  registrationId?: string | number;
  // Order & File Meta
  orderDate?: string;
  orderNo?: string;
  financialYear?: string;
  fileNumberPrefix?: string;
  rulesReferenceDate?: string;
  possessionDeadlineDays?: number;
  // Allotment Details
  employeeName?: string;
  employeeId?: string;
  empId?: string;
  pool?: string;
  quarterType?: string;
  flatNumber?: string;
  flatNo?: string;
  location?: string;
  category?: string;
  // Terms & Conditions (1 to 7)
  terms?: string[];
  // Signatory
  signatoryName?: string;
  signatoryDesignation?: string;
  // Distribution
  copyToList?: string[];
  ccTo?: string;
}

const getAuthHeaders = () => {
  let token: string | null = null;
  try {
    token = tokenService.getToken();
  } catch (e) {}

  const bearer = token ? (token.startsWith("Bearer ") ? token : `Bearer ${token}`) : "";
  return {
    "Content-Type": "application/json",
    ...(bearer ? { Authorization: bearer } : {}),
  };
};

export const extractTemplateData = (res: any) => {
  let d = res;
  if (d?.data?.data && typeof d.data.data === "object") {
    return d.data.data;
  }
  if (d?.data && typeof d.data === "object" && (d.data.terms || d.data.termsAndConditions || d.data.signatoryName || d.data.letterType)) {
    return d.data;
  }
  if (d?.data && typeof d.data === "object") {
    return d.data;
  }
  return d || {};
};

export const fetchLetterTemplate = async (type: string = "ALLOTMENT_LETTER") => {
  const url = API_URLS.STAFF_QUARTERS_LETTERS.GET_TEMPLATE(type);
  const response = await axios.get(url, { headers: getAuthHeaders() });
  return extractTemplateData(response.data);
};

export const saveLetterTemplate = async (
  type: string = "ALLOTMENT_LETTER",
  data: {
    signatoryName?: string;
    signatoryDesignation?: string;
    terms?: string[];
    copyToList?: string[];
    ccTo?: string;
  }
) => {
  const url = API_URLS.STAFF_QUARTERS_LETTERS.SAVE_TEMPLATE(type);
  const response = await axios.post(url, data, { headers: getAuthHeaders() });
  return response.data;
};

export const resetLetterTemplate = async (type: string = "ALLOTMENT_LETTER") => {
  const url = API_URLS.STAFF_QUARTERS_LETTERS.RESET_TEMPLATE(type);
  const response = await axios.post(url, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const fetchAllotmentLetterPreview = async (payload: AllotmentLetterFormValues) => {
  const url = API_URLS.STAFF_QUARTERS_LETTERS.ALLOTMENT_DATA;
  const response = await axios.post(url, payload, { headers: getAuthHeaders() });
  return response.data;
};

export const downloadAllotmentLetterPdf = async (
  payload: AllotmentLetterFormValues,
  filename?: string
) => {
  const url = API_URLS.STAFF_QUARTERS_LETTERS.ALLOTMENT_DOWNLOAD;
  const headers = getAuthHeaders();

  const response = await axios.post(url, payload, {
    headers,
    responseType: "blob",
  });

  const blob = new Blob([response.data], { type: "application/pdf" });
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;

  const resolvedName =
    filename ||
    `DMRC_Allotment_Order_${payload.orderNo || payload.employeeId || payload.allotmentId || Date.now()}.pdf`;

  link.setAttribute("download", resolvedName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
  return true;
};
